import { useSettingsStore } from '@/store/settings'
import { requiredUrls } from '@/store/settings/types'
import { Settings } from '@/types'
import { createPinia } from 'pinia'
import { App } from 'vue'

export default {
  install: (app: App<Element>, settings: Settings) => {
    app.use(createPinia())

    const store = useSettingsStore()
    const urls: requiredUrls = {
      changePasswordUrl: settings.changePasswordUrl,
      helpUrl: settings.helpUrl,
      manageUserDataUrl: settings.manageUserDataUrl,
      newsletterUrl: settings.newsletterUrl,
      poweredByUrl: settings.poweredByUrl,
      productFruitKey: settings.productFruitKey
    }
    store.$patch({
      backendUrl: settings.backendUrl,
      showContextualMenu: settings.showContextualMenu ?? false,
      urls
    })
  }
}
